"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = createAssetUploaderHandlers;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _lodash = _interopRequireDefault(require("lodash.throttle")),
    _assets = require("../assets"),
    _constants = require("../../constants");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var source, i = 1; i < arguments.length; i++) {
    source = null == arguments[i] ? {} : arguments[i], i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function createAssetUploaderHandlers(_ref) {
  var handleAssetUpdates = _ref.handleAssetUpdates,
      totalSize = _ref.totalSize,
      asset = _ref.asset,
      originalFile = _ref.originalFile,
      apiClient = _ref.apiClient,
      assetId = asset.assetId,
      assetFiles = asset.assetFiles,
      organisationId = asset.organisationId,
      uploadedSize = 0,
      progress = function progress(currentUploaded) {
    uploadedSize = currentUploaded;
    var loadedPercent = Math.floor(100 * (uploadedSize / totalSize));
    handleAssetUpdates([{
      assetId: assetId,
      loaded: uploadedSize,
      totalSize: totalSize,
      loadedPercent: 100 > loadedPercent ? loadedPercent : 100,
      uploadStatus: _constants.ITEM_STATUS.ACTIVE
    }]);
  },
      complete = function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
      var updatedFile;
      return _regenerator["default"].wrap(function (_context) {
        for (;;) {
          switch (_context.prev = _context.next) {
            case 0:
              return originalFile.setCompleted(), _context.next = 3, (0, _assets.updateFile)(apiClient, {
                organisationId: organisationId,
                assetFileId: assetFiles.ORIGINAL.assetFileId,
                input: {
                  status: _constants.ASSET_STATUS.UPLOADED
                }
              });

            case 3:
              if (updatedFile = _context.sent, updatedFile) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              assetFiles.ORIGINAL = _objectSpread({}, assetFiles.ORIGINAL, {}, updatedFile), handleAssetUpdates([_objectSpread({}, asset, {
                loadedPercent: 100,
                loaded: totalSize
              })]), setTimeout(function () {
                handleAssetUpdates([_objectSpread({}, asset, {
                  uploadStatus: _constants.ITEM_STATUS.SUCCESS
                })]);
              }, _constants.REMOVE_COMPLETED_DELAY);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    error: function error() {
      handleAssetUpdates([{
        assetId: assetId,
        uploadStatus: _constants.ITEM_STATUS.ERROR
      }]);
    },
    progress: (0, _lodash["default"])(progress, _constants.PROGRESS_THROTTLE),
    complete: complete
  };
}